import type {ComponentWithResolvedDataItems} from '@wix/document-services-types'
import type {CorePluginFunction} from '../../types'

export const unpack: CorePluginFunction = (componentExport: ComponentWithResolvedDataItems) => {
    delete componentExport.version
}
